import { NativeAudio } from "@ionic-native/native-audio";
// import { PlazaSelectThemePage } from "./../plaza-select-theme/plaza-select-theme";
import { TranslateService } from "@ngx-translate/core";
import { HomePage } from "./../home/home";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { PlazaSlotThemePage } from "../plaza-slot-theme/plaza-slot-theme";

@IonicPage()
@Component({
  selector: "page-plaza-select-theme-save",
  templateUrl: "plaza-select-theme-save.html",
})
export class PlazaSelectThemeSavePage {
  desc: any = { theme_name: "", cost: "", opex: "", total_cost: "" };
  theme_id: any;
  theme_no: any;
  theme = 1;
  themeNo = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private http: Http,
    private services: ServiceProvider,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private nativeAudio: NativeAudio
  ) {
    this.themeNo = this.navParams.data.themeNo;
    let res = this.navParams.data.theme;
    this.theme_id = res.theme_id;
    this.desc.theme_name = res.theme_name;
    this.desc.cost = this.services.currencyFormat(res.cost);
    this.desc.opex = this.services.currencyFormat(res.opex);
    let total_cost = parseFloat(res.cost) + parseFloat(res.opex);
    this.desc.total_cost = this.services.currencyFormat(total_cost);
    this.nativeAudio.preloadSimple("uniqueId2", "assets/sounds/cash.aac");
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  backPage() {
    this.navCtrl.setRoot(PlazaSlotThemePage);
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLThemeSave;
      var headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.storage.get("roundGame").then((roundGame) => {
        this.storage.get("themeSelect" + roundGame).then((theme_no) => {
          if (!theme_no) {
            this.theme_no = 1;
          } else {
            this.theme_no = theme_no + 1;
          }
          this.storage.set("themeSelect" + roundGame, this.theme_no);

          let body = "theme_no=" + this.themeNo + "&theme_id=" + this.theme_id;

          this.http
            .post(link, body, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                loader.dismiss();
                this.nativeAudio.play("uniqueId2");
                if (this.theme_no < 2) {
                  this.navCtrl.push(PlazaSlotThemePage);
                } else {
                  this.navCtrl.push(HomePage);
                }
              },
              (error) => {
                var response = JSON.parse(error._body);
                loader.dismiss();
                this.translateService
                  .get(response.message)
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
              }
            );
        });
      });
    });
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-theme-save/plaza-select-theme-save.ts